import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

const KEY = "oor_inbox_passcode";

export const getStoredPasscode = () => sessionStorage.getItem(KEY);
export const setStoredPasscode = (v) => sessionStorage.setItem(KEY, v);
export const clearStoredPasscode = () => sessionStorage.removeItem(KEY);

export const inboxGet = async (path) => {
  const res = await api.get(path, {
    headers: { "X-Admin-Passcode": getStoredPasscode() || "" },
  });
  return res.data;
};
